'use client'

import { useTranslate } from '@repo/shared/hooks'
import {
  // Badge,
  Card,
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@repo/ui/components'

import { useIsDesktop } from '@repo/ui/hooks'
import { MessageItems } from './message.items'
import { MessagesCTA } from './messages.cta'

export type MessageType =
  | 'security'
  | 'system'
  | 'announcement'
  | 'otc'
  | 'payment'
  | 'all'
export const MessagesContainer = () => {
  const { t } = useTranslate()

  const isDesktop = useIsDesktop()

  const tabs = [
    {
      value: 'all',
      label: t('profileMessagesPage_tab_all'),
    },
    {
      value: 'security',
      label: t('profileMessagesPage_tab_security'),
    },
    {
      value: 'payment',
      label: t('profileMessagesPage_tab_deposit'),
    },
    {
      value: 'otc',
      label: t('profileMessagesPage_tab_buy_sell'),
    },
    {
      value: 'announcement',
      label: t('profileMessagesPage_tab_notifications'),
    },
    {
      value: 'system',
      label: t('profileMessagesPage_tab_system'),
    },
  ]

  return (
    <Card withoutBorder>
      {isDesktop && <MessagesCTA origin='container' />}

      <Tabs defaultValue='all' color='base' size='md'>
        <TabsList className='w-full md:w-fit'>
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value}>
              {tab.label}
              {/* {tab.value === 'all' && (
                <Badge size='sm' color='base' variant='liquid'>
                  10
                </Badge>
              )} */}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value}>
            <MessageItems tab={tab.value as MessageType} />
          </TabsContent>
        ))}
      </Tabs>
    </Card>
  )
}
